import React from "react"
//import I18n from "i18n-js/index.js.erb"

class PreviewPopoverNotes extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var actions = [<a key={'edit'} href={`admin/notes/${this.props.model_id}/${false}/popover_edit`} className='btn btn-sm modal-iframe' data-nested='true' data-fullscreen='true'>{I18n.t('edit')}</a>, <a key={'view'} href={`admin/notes/${this.props.model_id}/${true}/popover_edit`} className='btn btn-sm modal-iframe' data-nested='true' data-fullscreen='true'>{I18n.t('view')}</a>]
    return(
      <div className="popover-preview">
        <div className="popover-close-wrapper"><button type="button" className="close" onClick={$(this).parents('.popover').popover('hide')}><span aria-hidden="true">x</span><span className="sr-only">Close</span></button></div>
        <div className="popover-heading">
          <h3><div className="model-card" style={{ paddingLeft: '10px' }}><span className="ss-notepad">&nbsp;</span></div>{`${this.props.text} ${I18n.t('notes')}`}</h3>
        </div>

        <div className="popover-body">
          {this.renderNoteCounts()}
        
          <hr style={{ margin: '5px 0 10px 0' }} />
          <div className="quick-links">{actions}</div>
        </div>
      </div>
    );
  };

  renderNoteCounts(){
    var noteKeys = Object.keys(this.props.note_counts)
    var noteCounts = noteKeys.filter(key => this.props.note_counts[key])

    if(noteCounts.length) {
      return noteCounts.map((key) => {
        return (
          <div className="row" key={key}>
            <div className="col-xs-12">
              <label>{I18n.t(key)} :</label> <div className="value" style={{display:'inline-block', marginBottom:0}}>{this.props.note_counts[key]}</div>
            </div>
          </div>
        );
      });
    } else {
      return <label>{I18n.t('none')}</label>
    };
  };
};

export default PreviewPopoverNotes